import styled from "@emotion/styled";
import { Box, Button, Chip } from "@mui/material";
import React from "react";
import { MinusIcon, PlusIcon } from "src/icons/filter";

const CartQuantityButton = styled(Button)(({ theme }) => ({
  padding: 0,
  width: 25,
  minWidth: "auto",
  height: 20,
  position: "absolute",
  top: "22%",
  "&.right": {
    left: -10,
  },
  "&.left": {
    right: -10,
  },
}));

const Quantity = ({ onIncrease, onDecrease, data, quantity = 1 }) => {
  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <CartQuantityButton
        className="right"
        variant="contained"
        onClick={() => onIncrease(data)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-100 h-100"
        >
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </CartQuantityButton>
      <Chip label={quantity} sx={{ width: 70, height: 40 }} />
      <CartQuantityButton
        className="left"
        variant="contained"
        onClick={() => onDecrease(data)}
      >
        <svg
          width={18}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-100 h-100"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </CartQuantityButton>
    </Box>
  );
};

export default Quantity;
